import { render, staticRenderFns } from "./DuplicateShipment.vue?vue&type=template&id=eedeb028&scoped=true"
import script from "./DuplicateShipment.vue?vue&type=script&lang=js"
export * from "./DuplicateShipment.vue?vue&type=script&lang=js"
import style0 from "./DuplicateShipment.vue?vue&type=style&index=0&id=eedeb028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedeb028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VSkeletonLoader})
